import logo from "./logo.svg";
import PortfolioContainer from "../src/pages/PortfolioContainer";

function App() {
  return (
      <PortfolioContainer />
  );
}

export default App;
